import {
  Environment,
  urlEnvironments,
  URLs,
} from '../constants/api-url.constants';

type EnvOptions = {
  environment?: Environment;
};

type EnvironmentConfig = {
  loopback: string;
  supabase: {url: string; anonKey: string};
  website: string;
};

export const getEnvironment = (options?: EnvOptions): Environment => {
  const hostname = window.location.hostname;
  const urlParams = new URLSearchParams(window.location.search);
  const environmentParam = urlParams.get('environment');

  if (options === undefined) {
    const urlParams = new URLSearchParams(window.location.search);
    const environment =
      (urlParams.get('environment') as Environment) ?? undefined;
    options = {environment};
  }

  const environment: Environment =
    options.environment ?? urlEnvironments[hostname] ?? 'production';
  if (!(environment in URLs)) {
    throw new Error(`Unknown environment ${environment}`);
  }

  return (
    (environmentParam as keyof typeof URLs) ??
    urlEnvironments[hostname] ??
    'production'
  );
};

export const getEnvironmentConfig = (
  environment?: Environment,
): EnvironmentConfig => {
  if (environment === undefined) {
    environment = getEnvironment();
  }

  return URLs[environment];
};
